import { render, staticRenderFns } from "./AppleMessagePWA.vue?vue&type=template&id=cee020f2&scoped=true&"
import script from "./AppleMessagePWA.vue?vue&type=script&lang=ts&"
export * from "./AppleMessagePWA.vue?vue&type=script&lang=ts&"
import style0 from "./AppleMessagePWA.vue?vue&type=style&index=0&id=cee020f2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cee020f2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VImg})
